import moment from 'moment';
import _ from 'lodash';
import API from '../../app/api';
import {PATIENT_TAGS} from '../../util/patientUtil';

export const ADMISSION_TYPE = {
    ED: 'ED',
    INPATIENT: 'INPATIENT',
};
export const AdmitBaseState = {
    accommodationStatus: null,
    addressLines: '',
    attendanceCategory: null,
    city: '',
    county: '',
    dob: null,
    ehic: null,
    ehicCard: null,
    ehicNumber: '',
    emailAdresses: [],
    employerAddress: '',
    employerName: '',
    employerPostalCode: '',
    escortArray: [],
    ethnicGroup: null,
    familyName: '',
    firstName: '',
    gender: null,
    gp: null,
    hospitalNumber: '',
    household: null,
    interpreterLanguage: null,
    middleNames: '',
    nhsBlockedProceeding: false,
    nhsNumber: '',
    noEhicReason: '',
    nokList: [],
    occupation: '',
    overseasStatus: null,
    patientNeedsInterpreter: false,
    patientUnknown: false,
    patientUpdate: false,
    phoneNumbers: [],
    postalCode: '',
    postTown: '',
    schoolAddress: '',
    schoolContact: '',
    schoolName: '',
    schoolPostalCode: '',
    speedRegistry: false,
    spokenLanguage: null,
    spokenLanguageExists: false,
    street: '',
    surgery: null,
};
export const getInitialAdmission = (externalConfig) => ({
    admitDate: moment(),
    ambulanceIncidentNumber: '',
    arrivalDateTime: null,
    assaultRelated: false,
    attendanceCategory: null,
    attendanceSource: null,
    attendanceType: null,
    careContactIdentifier: '',
    chiefComplaint: null,
    conveyingAmbulanceOrgId: '',
    cpIs: false,
    cpIsAlertPresent: false,
    department: null,
    escortArray: [],
    feedback: externalConfig?.feedback || true,
    flag111: false,
    flag111Timestamp: null,
    historyOfPresentingComplaint: '',
    lastAttendanceId: '',
    location: null,
    majorTraumaFlag: false,
    modeOfArrival: null,
    placeOfInjury: null,
    ward: null,
});

export function getConsultantName(value) {
    if (!value) return '';
    const familyName = _.capitalize(value.familyName);
    const firstName = _.capitalize(value.firstName);
    return `${familyName}, ${firstName}`;
}

export async function attendanceFromData(admission, locationDict, admissionTypeDict, intendedManagements, chiefComplaintDict, arrivalModeDict) {
    const controller = new AbortController();
    let attendance = {
        admitDate: moment(admission.admission.startDate),
        location: _.find(locationDict, {__code: admission.admission.attendanceType}),
    };
    if (admission.admission.endDate) {
        attendance.dischargeDate = moment(admission.admission.endDate);
    }
    attendance.dischargeDestinationDescription = admission.admission.dischargeDestinationDescription;
    attendance.dischargeMethodDescription = admission.admission.dischargeMethodDescription;

    if (admission.admission.admissionTypeCode) {
        attendance.attendanceType = _.find(admissionTypeDict, {__code: admission.admission.admissionTypeCode});
    }
    if (admission.admission.intendedManagementCode) {
        attendance.managementIntention = _.find(intendedManagements, {__code: admission.admission.intendedManagementCode});
    }
    if (admission.admission.consultant) {
        let consultantId = getIdFromHref(admission.admission.consultant?.href);
        await API.getConsultantsByIds([consultantId], controller.signal).then(res => {
            if (res.__data && res.__data.length > 0) {
                attendance.consultant = res.__data[0];
            }
        });
    }
    if (admission.admission.specialtyCode) {
        await API.getDictByURL(`/$dict/Specialties?$filter=${encodeURIComponent(`code eq '${admission.admission.specialtyCode}'`)}`, controller.signal).then(dictData => {
            if (dictData && dictData.__data?.length > 0) {
                attendance.specialty = dictData.__data[0];
            }
        });
    }
    if (admission.wardId) {
        API.getWard(admission.wardId, controller.signal).then(ward => {
            attendance.ward = ward;
        });
    }
    if (admission.admission.inpatientInWardLocation) {
        attendance.bay = admission.admission.inpatientInWardLocation.bay;
        attendance.bed = admission.admission.inpatientInWardLocation.bedNumber;
    }
    if (admission.admission.expectedDischargeDate) {
        attendance.expectedDischargeDate = moment(admission.admission.expectedDischargeDate);
    }
    if (admission.admission.clinic) {
        attendance.clinic = admission.admission.clinic;
    }
    if (admission.admission.appointmentTypeCode) {
        if (admission.admission.appointmentType === 'N') {
            attendance.appointmentType = {description: 'New', value: 'N', id: 'NEW'};
        } else if (admission.admission.appointmentType === 'F') {
            attendance.appointmentType = {description: 'Follow-up', value: 'F', id: 'OLD'};
        } else {
            attendance.appointmentType = {description: 'Other', value: 'O', id: 'O'};
        }

    }
    if (admission.admission.arrivalModeCode) {
        attendance.modeOfArrival = _.find(arrivalModeDict, {snomedCode: admission.admission.arrivalModeCode});
        if (!attendance.modeOfArrival) {
            attendance.modeOfArrival = _.find(arrivalModeDict, {code: admission.admission.arrivalModeCode});
        }
    }
    if (admission.admission.initialAEComplaintSnomedCode) {
        attendance.chiefComplaint = _.find(chiefComplaintDict, {snomedCode: admission.admission.initialAEComplaintSnomedCode});
        attendance.chiefComplaint2 = _.find(chiefComplaintDict, {snomedCode: admission.admission.initialAEComplaintSnomedCode});
    }
    attendance.sourceAdmission = admission.admission;
    // attendanceSource: null,
    // ambulanceIncidentNumber: "",
    // conveyingAmbulanceOrgId: "",
    // careContactIdentifier: '',
    // arrivalDateTime: null,
    // attendanceType: null,
    // chiefComplaint: null,
    // historyOfPresentingComplaint: "",
    // department: null,
    // location: null,
    // modeOfArrival: null,
    // placeOfInjury: null,
    // majorTraumaFlag: false,
    // flag111: false,
    // flag111Timestamp: null,
    // lastAttendanceId: "",
    // attendanceCategory: null,
    // escortArray: [],
    // cpIs: false,
    // cpIsAlertPresent: false,
    // assaultRelated: false,
    // feedback: externalConfig?.feedback || false,
    return attendance;
}

export const admitGetAttendanceData = (admitObj) => {
    let res = {};
    res.clinic = admitObj.clinic;
    res.specialty = admitObj.specialty;
    res.appointmentType = admitObj.appointmentType;
    res.managementIntention = admitObj.managementIntention;
    if (admitObj.consultant) {
        res.consultant = admitObj.consultant.__id;
    }
    res.expectedDischargeDate = admitObj.expectedDischargeDate;
    res.bay = admitObj.bay;
    res.bed = admitObj.bed;
    res.ward = admitObj.ward;
    if (admitObj.sourceAdmission) {
        res.attendanceToUpdate = admitObj.sourceAdmission.attendanceId;
        res.attendanceToUpdateId = admitObj.sourceAdmission.__id;
        if (admitObj.sourceAdmission.facility) {
            res.facility = admitObj.sourceAdmission.facility;
        }
    }
    return res;
};

export const getIdFromHref = (href) => {
    if (href && href.length > 0) {
        let matchRes = href.match(/\/([^\/]+)$/);
        if (matchRes && matchRes.length > 1)
            return matchRes[1];
    }
    return '';
};

export const initBulkAdmission = () => {
    return {
        admitDate: null,
        attendanceSource: null,
        ambulanceIncidentNumber: '',
        conveyingAmbulanceOrgId: '',
        careContactIdentifier: '',
        arrivalDateTime: null,
        attendanceType: null,
        chiefComplaint: null,
        historyOfPresentingComplaint: '',
        department: null,
        location: null,
        modeOfArrival: null,
        placeOfInjury: null,
        lastAttendanceId: '',
        attendanceCategory: null,
        escortArray: [],
    };
};

export const admitBaseGen = () => {
    const randomString = (length, chars) => {
        let result = '';
        for (let i = length; i > 0; --i) result += chars[Math.floor(Math.random() * chars.length)];
        return result;
    };
    return {
        patientUpdate: false,
        patientUnknown: false,
        addressLines: '',
        street: 'Pen Dor',
        city: 'BURNLEY',
        postTown: 'Halifax Road',
        county: '',
        // cpIs: false,
        // cpIsAlertPresent: false,
        dob: moment('2005-09-06'),
        ethnicGroup: {
            'group': 'White',
            '__id': 'A',
            '__code': 'A',
            '__description': 'British',
        },
        familyName: `ADMT${randomString(5, '0123456789')}`,
        firstName: 'Ian',
        gender: {
            'cdsCode': '1',
            '__id': '2',
            '__code': '1',
            '__description': 'Male',
        },
        hospitalNumber: `D${randomString(5, '0123456789')}AT`,
        middleNames: '',
        nhsNumber: `NHS${randomString(5, '0123456789')}AT`,
        ehicCard: null,
        ehicNumber: '',
        noEhicReason: '',
        occupation: '',
        overseasStatus: {
            '__id': '9',
            '__code': '9',
            '__description': 'Not Known (Not Recorded)',
        },
        postalCode: 'BB10 3QS',
        schoolAddress: '',
        schoolName: '',
        schoolPostalCode: '',
        schoolContact: '',
        spokenLanguage: null,
        spokenLanguageExists: false,
        interpreterLanguage: null,
        accommodationStatus: null,
        patientNeedsInterpreter: false,
        attendanceCategory: null,
        speedRegistry: false,
        escortArray: [],
        household: null,
        nokList: [{
            'firstName': 'Ian',
            'lastName': 'Brother',
            'relationship': {
                '__id': 'B',
                '__code': 'B',
                '__description': 'BROTHER',
            },
            'address': '',
            'postalCode': '',
            'phoneNumber': '111111111111',
        }],
        employerName: '',
        employerPostalCode: '',
        employerAddress: '',
        phoneNumbers: [{
            'number': randomString(9, '0123456789'),
            'type': 'Work',
        }],
        emailAdresses: [],
        gp: {
            'names': null,
            'title': 'Dr',
            'firstName': 'BRAWDY MEDICAL CENTRE MO',
            'middleNames': null,
            'familyName': 'BRAWDY MEDICAL CENTRE MO',
            'dob': null,
            'genderCode': null,
            'initials': null,
            'gpCode': 'G6903491',
            'emailAddress': null,
            'address': {
                'lines': [
                    'BRAWDY MEDICAL CENTRE',
                    'THE MEDICAL CENTRE',
                    'CAWDOR',
                    'HAVERFORDWEST',
                ],
                'postalCode': 'SA62 6NN',
                'type': null,
                'clinicalCareGroup': null,
            },
            'phoneNumber': '',
            'surgery': {
                'href': '/surgeries/A91168',
            },
            'joinParent': '2015-01-27T00:00:00.000+0000',
            'leftParent': null,
            '__id': 'G6903491',
            '__version': '1.0',
            '__href': '/gp/G6903491',
            '__type': 'com.fortrus.unity.api.model.Gp',
        },
        surgery: {
            'practiceCode': 'A91168',
            'practiceName': 'BRAWDY MEDICAL CENTRE',
            'primaryCareOrganisation': null,
            'addresses': [
                {
                    'typeName': null,
                    'addressLines': [
                        'BRAWDY MEDICAL CENTRE',
                        'THE MEDICAL CENTRE',
                        'CAWDOR',
                        'HAVERFORDWEST',
                    ],
                    'postalCode': 'SA62 6NN',
                    '__id': null,
                    '__version': '1.0',
                    '__href': '/patients/null',
                    '__type': 'com.fortrus.unity.api.model.Address',
                },
            ],
            'emails': null,
            'phoneNumbers': [
                {
                    'phone': '',
                    'type': 'Home',
                    'code': null,
                    'isActive': true,
                },
            ],
            '__id': 'A91168',
            '__version': '2.0',
            '__href': '/surgeries/A91168',
            '__type': 'com.fortrus.unity.api.model.Surgery',
        },
        nhsBlockedProceeding: false,
    };
};

export const isChild = (patientAge) => {
    return patientAge < 18;
};

export const admitBase = () => {
    return {
        patientUpdate: false,
        patientUnknown: false,
        addressLines: '',
        street: '',
        city: '',
        postTown: '',
        county: '',
        // cpIs: false,
        // cpIsAlertPresent: false,
        dob: null,
        ethnicGroup: null,
        familyName: '',
        firstName: '',
        gender: null,
        hospitalNumber: '',
        middleNames: '',
        nhsNumber: '',
        ehicCard: null,
        ehicNumber: '',
        noEhicReason: '',
        occupation: '',
        overseasStatus: null,
        postalCode: '',
        schoolAddress: '',
        schoolName: '',
        schoolPostalCode: '',
        schoolContact: '',
        spokenLanguage: null,
        spokenLanguageExists: false,
        interpreterLanguage: null,
        accommodationStatus: null,
        patientNeedsInterpreter: false,
        attendanceCategory: null,
        speedRegistry: false,
        escortArray: [],
        household: null,
        nokList: [],
        employerName: '',
        employerPostalCode: '',
        employerAddress: '',
        phoneNumbers: [],
        emailAdresses: [],
        gp: null,
        surgery: null,
        nhsBlockedProceeding: false,
    };
};

export const checkIfPatientIsTemporary = (patient) => {
    if (!patient?.tags) return false;
    return patient.tags.includes(PATIENT_TAGS.TEMPORARY) ||
        patient.tags.includes(PATIENT_TAGS.UNKNOWN);
};